import { RemovePersonaModalSubmitter } from '../../lib/remove-persona-modal/remove-persona-modal-submit.service'
import { DocsRemovePersonaModalSubmitter } from './docs-remove-persona-modal-submitter.service'

export const PROVIDERS = [
  {
    provide: RemovePersonaModalSubmitter,
    useClass: DocsRemovePersonaModalSubmitter
  }
]
